<template>
  <div class="mb-2"
    v-outside-click="{
      exclude: [],
      handler: 'closeDropdown'
    }">
    <div class="relative">
      <button
        type="button"
        @click="toggleDropdown">
       <slot></slot>
      </button>
      <div class="absolute z-50 right-0 w-fit p-1 mt-1 bg-white border border-gray-300 rounded-md shadow-lg" :class="{ 'hidden': !isOpen }">
        <div class="max-h-80">
          <div v-for="(action, index) in actions" :key="index" >
            <label class="flex items-center px-3 py-2 m-0 whitespace-nowrap">
              <button
                type="button"
                @click="handleClick(action.callback)"
                class="text-indigo-600 transition duration-150 ease-in-out"
              >
              {{ action.name }}
              </button>
            </label>
            <hr v-if="action.seprator" class="my-1 mx-2 border-t border-gray-300 w-5/6">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    actions: Array,
  },
  data() {
    return {
      isOpen: false,
      open: false,
      searchQuery: '',
      checkBoxSelected: false,
    }
  },
  computed: {

  },
  eventCallbackIds: {},
  methods: {

    toggleDropdown() {
      this.isOpen = !this.isOpen
    },
    closeDropdown() {
      this.isOpen = false
    },
    handleClick(callback) {
      this.$emit(callback)
    },
  }
}
</script>
